import React from "react";
import { Flex, Spacer } from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";

import dashboardIcon from "../../../images/icons/dashboard.svg";
import dashboardRedIcon from "../../../images/icons/dashboardRed.svg";
import dataSourcesIcon from "../../../images/icons/dataSources.svg";
import dataSourcesRedIcon from "../../../images/icons/dataSourcesRed.svg";
import settingIcon from "../../../images/icons/setting.svg";
import settingRedIcon from "../../../images/icons/settingRed.svg";
import taxReportRedIcon from "../../../images/icons/taxReportRed.svg";
import taxReportsIcon from "../../../images/icons/taxReports.svg";
import transactionsIcon from "../../../images/icons/transactions.svg";
import transactionsRedIcon from "../../../images/icons/transactionsRed.svg";

import { NavLink } from "./NavLink";

export const NavbarLinks = ({ onClose }: { onClose: () => void }) => {
  const { pathname } = useLocation();
  return (
    <Flex direction="column" justifyContent="space-between">
      <NavLink
        to="/dashboard"
        content="Dashboard"
        icon={pathname === "/dashboard" ? dashboardRedIcon : dashboardIcon}
        active={pathname === "/dashboard"}
        onClose={onClose}
      />
      <NavLink
        to="/data-sources"
        content="Data Sources"
        icon={
          pathname === "/data-sources" ? dataSourcesRedIcon : dataSourcesIcon
        }
        active={pathname === "/data-sources"}
        onClose={onClose}
      />
      <NavLink
        to="/transactions"
        content="Transactions"
        icon={
          pathname === "/transactions" ? transactionsRedIcon : transactionsIcon
        }
        active={pathname === "/transactions"}
        onClose={onClose}
      />
      <NavLink
        to="/tax-reports"
        content="Tax Reports"
        icon={pathname === "/tax-reports" ? taxReportRedIcon : taxReportsIcon}
        active={pathname === "/tax-reports"}
        onClose={onClose}
      />
      <Spacer />
      <NavLink
        to="/settings"
        content="Settings"
        icon={pathname === "/settings" ? settingRedIcon : settingIcon}
        active={pathname === "/settings"}
        onClose={onClose}
      />
    </Flex>
  );
};
